import React from 'react';
import { Container, type ContainerProps } from 'react-bootstrap';
import { clsx } from '../helpers/clsx.js';

type ICentredPageMainContainer = {
  maxWidth?: string;
} & ContainerProps;
export const CentredPageMainContainer = ({
  className,
  children,
  maxWidth = '750px',
  ...props
}: ICentredPageMainContainer) => {
  return (
    <Container className={clsx('m-0', 'p-0', className)} fluid {...props}>
      <div className="mx-auto" style={{ maxWidth }}>
        {children}
      </div>
    </Container>
  );
};
